export default {
  loginHeader: 'ご注文の詳細や配送番号の確認、領収書発行ができます',
  loginDescription:
    '注文番号、パスワードは注文完了メールにてご確認いただけます。',
  orderNumber: '注文番号',
  password: 'パスワード',
  checkFromOrderNumber: '確認する',
  historyHeader: 'ご注文内容',
  orderDate: '注文日',
  deliveryInfo: 'ゆうパック配送状況',
  orderInfo: '注文情報',
  ordererInfo: 'ご注文者',
  orderDetail: 'ご注文内容',
  expires: '有効期限',
  totalVoucherPrice: 'ギフト券代',
  totalDeliveryPrice: '配送料',
  itemNumber: '注文枚数',
  bill: 'ご請求金額',
  paymentType: 'お支払い方法',
  invoicing: '請求書（お振込み口座）',
  receiptIssue: '領収書',
  destination: '注文',
  scheduledOn: '配送指定日',
  notYetScheduled: '指定なし',
  scheduledOnTime: '配送指定時間',
  numberOfGiftCards: 'ギフト券枚数',
  client: '差出人',
  inscription: '熨斗紙・掛け紙',
  messageCard: 'メッセージカード',
  trackingNumber: '配送番号',
  receiver: 'お届け先',
  wrappingTypeNoName: 'なし',
  wrappingInfoLabel: '表示内容',
  grayHeaderText: 'ご注文の確認'
};



// WEBPACK FOOTER //
// ./src/i18n/ja/mypage.js